import {
    Box,
    CircularProgress,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    TableHead,
    TableRow,
    Divider,
} from "@mui/material";

const FittingRecommendHeader = ({recommendHeader, isLoading}) => {
    const renderProduct = (product, orderStatus) => {
        return (
            <TableRow key={product.id}>
                <TableCell>* {product.name}</TableCell>
                <TableCell>
                    <Typography variant="body2">
                        <strong>SKU:</strong> {product.sku}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Description:</strong> {product.description}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Model Name:</strong> {product.modelName}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Size:</strong> {product.sizeCode}
                    </Typography>
                </TableCell>
                <TableCell align="center">
                    <Typography>
                        <b>{orderStatus}</b>
                    </Typography>
                </TableCell>
            </TableRow>
        );
    };
    const renderClubConfig = (clubConfig, orderStatus) => {
        return (
            <TableRow key={clubConfig.id}>
                <TableCell>
                    <Typography variant="body2">{clubConfig.displayHeadModelName} </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="body2">
                        <strong>Hand:</strong> {clubConfig.handCode}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Gender:</strong> {clubConfig.genderCode}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Loft:</strong> {clubConfig.headLoft}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Sleeve Adj:</strong> {clubConfig.headSleeveAdj}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Head Weight:</strong> {clubConfig.headWeight ?? ""}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Shaft:</strong> {clubConfig.shaftVendorName} {clubConfig.shaftModelName}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Flex:</strong> {clubConfig.shaftFlex}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Tipping Adj:</strong> {clubConfig.shaftTippingAdj ?? ""}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Length Adj:</strong> {clubConfig.shaftLengthAdj ?? ""}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Grip:</strong> {clubConfig.gripVendor} {clubConfig.gripModel}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Wraps:</strong> {clubConfig.gripWraps}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Logo:</strong> {clubConfig.gripLogo}
                    </Typography>
                </TableCell>
                <TableCell align="center">
                    <Typography>
                        <b>{orderStatus}</b>
                    </Typography>
                </TableCell>
            </TableRow>
        );
    };
    const renderProductTable = (recommendHeader) => {
        const recommendLines = recommendHeader?.recommendLines;
        return (
            <>
                {recommendLines.map((line) => {
                    let orderStatus = "Not Ordered in MFE";
                    if (line?.builtQuantity > 0) {
                        orderStatus = "Built";
                    } else if (line?.orderedQuantity > 0) {
                        orderStatus = "Ordered in MFE";
                    }
                    const clubConfig = line.clubConfig;
                    const product = line.product;
                    if (!clubConfig && !product) return null;
                    if (clubConfig == null) {
                        return renderProduct(product, orderStatus);
                    }
                    return renderClubConfig(clubConfig, orderStatus);
                })}
            </>
        );
    };
    const recommendLines = recommendHeader?.recommendLines;
    const hasNoData = !isLoading && (!recommendLines || recommendLines.length === 0);

    const renderNoData = () => (
        <Box sx={{p: 3, textAlign: "center", display: "flex", justifyContent: "center"}}>
            <Typography variant="body1">No Fitting Data</Typography>
        </Box>
    );

    const renderLoading = () => (
        <Box sx={{display: "flex", justifyContent: "center", p: 5}}>
            <CircularProgress />
        </Box>
    );

    const renderTable = () => (
        <>
            <Typography sx={{textAlign: "center", background: "#d8d8d8"}} variant="h6" my={1}>
                RECOMMEND HEADER
            </Typography>
            <TableContainer component={Paper}>
                <Box>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <strong>PRODUCT</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>DETAILS</strong>
                                </TableCell>
                                <TableCell align="center">
                                    <strong>STATUS</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {renderProductTable(recommendHeader)}
                        </TableBody>
                    </Table>
                </Box>
            </TableContainer>
        </>
    );

    let content;
    if (hasNoData) {
        content = renderNoData();
    } else if (isLoading) {
        content = renderLoading();
    } else {
        content = renderTable();
    }

    return (
        <Grid item xs={12}>
            {content}
        </Grid>
    );
};
export default FittingRecommendHeader;
